// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  /* Hide unnecessary background colors and fixed controls */
  html, body {
    background: white !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .backbutton-sticky {
    display: none !important;
  }

  .print-root {
    padding: 0 !important;
    margin: 0 !important;
    display: block !important; /* Switch from flex to standard block flow for print */
  }

  .print-page-portrait {
    margin: 0 !important;
    box-shadow: none !important;
    border: none !important;
    
    /* Strict sizing to match paper dimensions */
    width: 8.5in !important;
    height: 10.99in !important; /* Slight drop from 11in prevents 1px height overflows */
    box-sizing: border-box !important;

    /* Clean page breaks */
    break-after: page;
    page-break-after: always;
  }

  /* Prevent trailing blank page at the end of the document */
  .print-page-portrait:last-child {
    break-after: auto;
    page-break-after: auto;
  }
}

body {
  margin: 0;
  padding: 0;
  background-color: #9cb2a6;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
}

.print-page-portrait {
  width: 8.5in;
  height: 11in;
  background: #ffffff;
  box-sizing: border-box;
  padding: 0.4in 0.5in;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden; /* Prevents nested element overflow from pushing out extra space */
}

.loading-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.backbutton-sticky {
  position: fixed !important;
  top: 16px;
  right: 16px;
  z-index: 1000;
}

.print-root {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

/* Page Frame mimicking standard Letter Portrait proportions */
.print-page-portrait {
  width: 8.5in;
  height: 11in;
  background: #ffffff;
  box-sizing: border-box;
  padding: 0.4in 0.5in;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  page-break-after: always;
}

/* Header Rules */
.page-header {
  border-bottom: 1px solid #111;
  padding-bottom: 8px;
}

.header-title-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.doc-main-title {
  margin: 0;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.5px;
  color: #000;
}

.doc-subtitle {
  font-size: 18px;
  font-weight: 400;
  margin-left: 8px;
  color: #222;
}

.page-counter {
  font-size: 20px;
  font-weight: 500;
  color: #111;
}

.instruction-text {
  margin: 6px 0 0 0;
  font-size: 9px;
  line-height: 1.3;
  color: #555;
}

/* Body / Center View */
.page-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 0;
}

.top-content-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  flex: 1 1; /* Allows upper content to fill available vertical space above bottom views */
  min-height: 260px;
}

/* Left Column: Fixed/Max width so it doesn't expand indefinitely */
.table-wrapper {
  width: 45%;
  max-width: 320px;
  flex-shrink: 0; /* Prevents image from squeezing the table */
}

/* Parent wrapper serves as the positioning anchor */
.center-diagram-wrapper {
  position: relative;
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  min-height: 260px;
  overflow: hidden; /* Keeps rotated text contained within the bounds */
}

/* Image fills the wrapper cleanly */
.main-isometric-img {
  width: 120%;
  height: 120%;
  max-height: 780px;
  object-fit: contain;
  object-position: right;
}

.main-isometric-img.isu-diagram{
  width: 120%;
  height: 120%;
  max-height: 780px;
  object-fit: contain;
  object-position: right;
  transform: scale(2) translate(20px, 40px);
}

.main-isometric-img.pallet-diagram {
  max-height: 480px; /* Expands height boundary */
  
  transform: scale(2.05) translate(70px, 15px); 
  transform-origin: right center; /* Keeps zoom anchored to the right side */
}

/* Position text directly over the lower-right corner of the image canvas */
.door-opening-label {
  position: absolute;
  right: 42px;           /* Inset from the right edge */
  bottom: 60px;          /* Inset from the bottom edge */
  transform: rotate(-45deg);
  transform-origin: center;
  
  font-weight: 700;
  font-size: 23px;
  color: #000000;
  white-space: nowrap;
  pointer-events: none;  /* Lets clicks pass through to the image if needed */
  z-index: 2;            /* Keeps text layered above the image */
}

.step-table-container {
  border: 1px solid #e0e0e0;
}

.icon-symbol {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

/* Bottom Cards */
.bottom-views-container {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.view-card {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.view-card-title {
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 6px;
  letter-spacing: 0.5px;
  color: #111;
}

.view-card-content {
  width: 100%;
  height: 160px;
  border: 1.5px solid #000;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #fafafa;
}

.card-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.card-img.isu-card-img{
  transform: scale(1) translate(0px, 12px);
}
.card-img.pallet-card-img{
  transform: scale(1.2) translate(-39px, -10px);
}

.card-img-1 {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.card-img-1.isu-card-img {
  transform: scale(.9) rotate(0deg) translate(0px, 0px);
}
.card-img-1.pallet-card-img {
  transform: scale(1) rotate(-90deg) translate(60px, -10px);
}

.level-number-fallback {
  font-size: 96px;
  font-weight: 700;
  color: #000;
}

.placeholder-box {
  color: #888;
  font-size: 12px;
}

/* Footer Section */
.page-footer {
  border-top: 1px solid #111;
  padding-top: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 18px;
  font-size: 9px;
  color: #333;
}

.footer-label {
  font-weight: 800;
  margin-right: auto;
}

.footer-key-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.footer-key-item .bold {
  font-weight: 700;
}

.footer-key-icon {
  width: 14px;
  height: 14px;
  object-fit: contain;
  filter: grayscale(100%);
}

.no-boxes-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f5f5f5;
  position: relative;
}

.no-boxes-card {
  background: #ffffff;
  padding: 40px 60px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
  border: 1px solid #e0e0e0;
}

.no-boxes-card h2 {
  font-size: 22px;
  font-weight: 700;
  color: #333333;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/containers/PortraitPrintout/portrait.css"],"names":[],"mappings":"AAAA;EACE,0DAA0D;EAC1D;IACE,4BAA4B;IAC5B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;IACpB,yBAAyB,EAAE,sDAAsD;EACnF;;EAEA;IACE,oBAAoB;IACpB,2BAA2B;IAC3B,uBAAuB;;IAEvB,4CAA4C;IAC5C,uBAAuB;IACvB,0BAA0B,EAAE,wDAAwD;IACpF,iCAAiC;;IAEjC,sBAAsB;IACtB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA,2DAA2D;EAC3D;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB,EAAE,kEAAkE;AACtF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,SAAO,EAAE,6EAA6E;EACtF,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc,EAAE,4CAA4C;AAC9D;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB,EAAE,mDAAmD;AACvE;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB,EAAE,4BAA4B;;EAE/C,4CAA4C;EAC5C,8BAA8B,EAAE,0CAA0C;AAC5E;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,WAAW,YAAY,8BAA8B;EACrD,YAAY,WAAW,+BAA+B;EACtD,yBAAyB;EACzB,wBAAwB;;EAExB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB,GAAG,oDAAoD;EAC3E,UAAU,aAAa,uCAAuC;AAChE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;AACvD;AACA;EACE,yDAAyD;AAC3D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX","sourcesContent":["@media print {\n  /* Hide unnecessary background colors and fixed controls */\n  html, body {\n    background: white !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .backbutton-sticky {\n    display: none !important;\n  }\n\n  .print-root {\n    padding: 0 !important;\n    margin: 0 !important;\n    display: block !important; /* Switch from flex to standard block flow for print */\n  }\n\n  .print-page-portrait {\n    margin: 0 !important;\n    box-shadow: none !important;\n    border: none !important;\n    \n    /* Strict sizing to match paper dimensions */\n    width: 8.5in !important;\n    height: 10.99in !important; /* Slight drop from 11in prevents 1px height overflows */\n    box-sizing: border-box !important;\n\n    /* Clean page breaks */\n    break-after: page;\n    page-break-after: always;\n  }\n\n  /* Prevent trailing blank page at the end of the document */\n  .print-page-portrait:last-child {\n    break-after: auto;\n    page-break-after: auto;\n  }\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  background-color: #9cb2a6;\n  font-family: 'Open Sans', Helvetica, Arial, sans-serif;\n}\n\n.print-page-portrait {\n  width: 8.5in;\n  height: 11in;\n  background: #ffffff;\n  box-sizing: border-box;\n  padding: 0.4in 0.5in;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  overflow: hidden; /* Prevents nested element overflow from pushing out extra space */\n}\n\n.loading-screen {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.backbutton-sticky {\n  position: fixed !important;\n  top: 16px;\n  right: 16px;\n  z-index: 1000;\n}\n\n.print-root {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0;\n}\n\n/* Page Frame mimicking standard Letter Portrait proportions */\n.print-page-portrait {\n  width: 8.5in;\n  height: 11in;\n  background: #ffffff;\n  box-sizing: border-box;\n  padding: 0.4in 0.5in;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  page-break-after: always;\n}\n\n/* Header Rules */\n.page-header {\n  border-bottom: 1px solid #111;\n  padding-bottom: 8px;\n}\n\n.header-title-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.doc-main-title {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  color: #000;\n}\n\n.doc-subtitle {\n  font-size: 18px;\n  font-weight: 400;\n  margin-left: 8px;\n  color: #222;\n}\n\n.page-counter {\n  font-size: 20px;\n  font-weight: 500;\n  color: #111;\n}\n\n.instruction-text {\n  margin: 6px 0 0 0;\n  font-size: 9px;\n  line-height: 1.3;\n  color: #555;\n}\n\n/* Body / Center View */\n.page-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 12px 0;\n}\n\n.top-content-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  gap: 16px;\n  flex: 1; /* Allows upper content to fill available vertical space above bottom views */\n  min-height: 260px;\n}\n\n/* Left Column: Fixed/Max width so it doesn't expand indefinitely */\n.table-wrapper {\n  width: 45%;\n  max-width: 320px;\n  flex-shrink: 0; /* Prevents image from squeezing the table */\n}\n\n/* Parent wrapper serves as the positioning anchor */\n.center-diagram-wrapper {\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 100%;\n  min-height: 260px;\n  overflow: hidden; /* Keeps rotated text contained within the bounds */\n}\n\n/* Image fills the wrapper cleanly */\n.main-isometric-img {\n  width: 120%;\n  height: 120%;\n  max-height: 780px;\n  object-fit: contain;\n  object-position: right;\n}\n\n.main-isometric-img.isu-diagram{\n  width: 120%;\n  height: 120%;\n  max-height: 780px;\n  object-fit: contain;\n  object-position: right;\n  transform: scale(2) translate(20px, 40px);\n}\n\n.main-isometric-img.pallet-diagram {\n  max-height: 480px; /* Expands height boundary */\n  \n  transform: scale(2.05) translate(70px, 15px); \n  transform-origin: right center; /* Keeps zoom anchored to the right side */\n}\n\n/* Position text directly over the lower-right corner of the image canvas */\n.door-opening-label {\n  position: absolute;\n  right: 42px;           /* Inset from the right edge */\n  bottom: 60px;          /* Inset from the bottom edge */\n  transform: rotate(-45deg);\n  transform-origin: center;\n  \n  font-weight: 700;\n  font-size: 23px;\n  color: #000000;\n  white-space: nowrap;\n  pointer-events: none;  /* Lets clicks pass through to the image if needed */\n  z-index: 2;            /* Keeps text layered above the image */\n}\n\n.step-table-container {\n  border: 1px solid #e0e0e0;\n}\n\n.icon-symbol {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n}\n\n/* Bottom Cards */\n.bottom-views-container {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n}\n\n.view-card {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.view-card-title {\n  font-size: 11px;\n  font-weight: 700;\n  margin-bottom: 6px;\n  letter-spacing: 0.5px;\n  color: #111;\n}\n\n.view-card-content {\n  width: 100%;\n  height: 160px;\n  border: 1.5px solid #000;\n  border-radius: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  background-color: #fafafa;\n}\n\n.card-img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n.card-img.isu-card-img{\n  transform: scale(1) translate(0px, 12px);\n}\n.card-img.pallet-card-img{\n  transform: scale(1.2) translate(-39px, -10px);\n}\n\n.card-img-1 {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.card-img-1.isu-card-img {\n  transform: scale(.9) rotate(0deg) translate(0px, 0px);\n}\n.card-img-1.pallet-card-img {\n  transform: scale(1) rotate(-90deg) translate(60px, -10px);\n}\n\n.level-number-fallback {\n  font-size: 96px;\n  font-weight: 700;\n  color: #000;\n}\n\n.placeholder-box {\n  color: #888;\n  font-size: 12px;\n}\n\n/* Footer Section */\n.page-footer {\n  border-top: 1px solid #111;\n  padding-top: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 18px;\n  font-size: 9px;\n  color: #333;\n}\n\n.footer-label {\n  font-weight: 800;\n  margin-right: auto;\n}\n\n.footer-key-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.footer-key-item .bold {\n  font-weight: 700;\n}\n\n.footer-key-icon {\n  width: 14px;\n  height: 14px;\n  object-fit: contain;\n  filter: grayscale(100%);\n}\n\n.no-boxes-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100vw;\n  background-color: #f5f5f5;\n  position: relative;\n}\n\n.no-boxes-card {\n  background: #ffffff;\n  padding: 40px 60px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  border: 1px solid #e0e0e0;\n}\n\n.no-boxes-card h2 {\n  font-size: 22px;\n  font-weight: 700;\n  color: #333333;\n  margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
